import { Link } from "react-router-dom";
import { stats } from "../../../mocks/siteData";

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/2752483c5b40a58ac2360f818e049507.jpg"
          alt="Luxury interior design living room"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/35 to-black/10"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/25 to-transparent"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full pt-24 pb-32">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 border border-[#C9A961]/60 bg-[#C9A961]/10 px-4 py-1.5 rounded-full mb-7">
            <span className="w-1.5 h-1.5 bg-[#C9A961] rounded-full animate-pulse"></span>
            <span className="text-[#C9A961] text-xs font-semibold uppercase tracking-widest">
              Professional Interior Design Services
            </span>
          </div>

          <h1
            className="text-5xl lg:text-6xl xl:text-7xl font-semibold text-white leading-[1.08] mb-6"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Interior Design Plans That Transform Your Space —
            <em className="not-italic text-[#C9A961]"> Without the Guesswork</em>
          </h1>

          <p className="text-lg text-white/80 leading-relaxed mb-10 max-w-xl">
            Custom design proposals, layouts, and finish selections tailored precisely to your home, your style, and your budget.
          </p>

          <div className="flex flex-wrap gap-4 mb-16">
            <Link
              to="/#proposal"
              className="whitespace-nowrap inline-flex items-center gap-2 bg-[#C9A961] text-white font-semibold px-8 py-4 rounded-md hover:bg-[#b8924d] transition-all duration-300 cursor-pointer text-base"
            >
              Get Your Design Proposal
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </div>
            </Link>
            <Link
              to="/services"
              className="whitespace-nowrap inline-flex items-center gap-2 bg-white/10 border border-white/40 backdrop-blur-sm text-white font-medium px-8 py-4 rounded-md hover:bg-white/20 transition-all duration-300 cursor-pointer text-base"
            >
              Explore Our Services
            </Link>
          </div>

          <div className="flex flex-wrap gap-x-8 gap-y-3">
            {[
              { icon: "ri-layout-masonry-line", text: "Custom Design Plans" },
              { icon: "ri-money-dollar-circle-line", text: "Budget-Conscious" },
              { icon: "ri-global-line", text: "Remote + Local" },
              { icon: "ri-home-smile-line", text: "Residential Focus" },
            ].map((item) => (
              <div key={item.text} className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center text-[#C9A961]">
                  <i className={`${item.icon} text-sm`}></i>
                </div>
                <span className="text-white/75 text-sm">{item.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 bg-[#111111]/80 backdrop-blur-md border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
            {stats.map((stat) => (
              <div key={stat.label} className="text-center">
                <div
                  className="text-2xl font-semibold text-[#C9A961]"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  {stat.number}
                </div>
                <div className="text-xs text-white/50 mt-0.5">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
